<template>
  <div class="dashboard">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" :md="8">
        <el-card>
          <h3>欢迎使用后台管理系统</h3>
          <p>当前时间：{{ now }}</p>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return { now: new Date().toLocaleString() };
  }
};
</script>

<style scoped>
.dashboard {
  padding: 20px;
}
</style>
